import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './tokas.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/230712/tokas-le_mclaren60th/tokas-le_mclaren60th_{nnn}.png',
}

export default {
  supports360: false,
  layers: [body, background],
  resolveOptions: () => ({}),
}
